'use strict'

import en from './LangEnglish'
import ja from './LangJapanese'

// jsonを結合する
var prefCode = Object.assign(en, ja)

export { prefCode }



// WEBPACK FOOTER //
// ./src/lib/prefecture_code/index.js